import { render, staticRenderFns } from "./create-test.vue?vue&type=template&id=68a8d71e&scoped=true"
import script from "./create-test.vue?vue&type=script&lang=js"
export * from "./create-test.vue?vue&type=script&lang=js"
import style0 from "./create-test.vue?vue&type=style&index=0&id=68a8d71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8d71e",
  null
  
)

export default component.exports